export default "/_next/static/assets/default-content-header-image_8c8a0db55888ef8693df495d55dec5f7.webp";